module.exports = __webpack_public_path__ + "static/media/15-d-calendar.0d7996e4.jpg";